module.exports = __webpack_public_path__ + "img/GIS_Abduction.ce3a497e.svg";